var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      class: "pa-0" + (_vm.alignTop ? " align-start" : " align-center"),
      attrs: { id: "layout-container", fluid: "" },
    },
    [
      _c(
        "v-row",
        {
          staticClass: "pa-lg-3",
          attrs: { justify: "center", "no-gutters": "" },
        },
        [
          _vm.showNav
            ? _c(
                "v-col",
                {
                  ref: "navigation",
                  class: "pa-1",
                  attrs: {
                    id: "layout-navigation",
                    order: _vm.navigationOrders[_vm.currentBreakpoint],
                    cols: _vm.navigationCols[_vm.currentBreakpoint],
                  },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-2", attrs: { rounded: "lg" } },
                    [_vm._t("content-left")],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            {
              staticClass: "pa-1",
              staticStyle: { position: "relative", height: "min-content" },
              attrs: {
                id: "layout-content",
                order: _vm.contentOrders[_vm.currentBreakpoint],
                cols: _vm.contentCols[_vm.currentBreakpoint],
              },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-2 fill-height",
                  staticStyle: {
                    overflow: "auto",
                    display: "flex",
                    "flex-direction": "column",
                  },
                  attrs: { id: "layout-wrapper", rounded: "lg" },
                },
                [_vm._t("content-center")],
                2
              ),
            ],
            1
          ),
          _vm.showSort
            ? _c(
                "v-col",
                {
                  class: "pa-1",
                  attrs: {
                    id: "layout-search",
                    order: _vm.sortOrders[_vm.currentBreakpoint],
                    cols: _vm.sortCols[_vm.currentBreakpoint],
                  },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-2", attrs: { rounded: "lg" } },
                    [_vm._t("content-right")],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }